import React from 'react';
import ArrowCircularOutlined from '@uber/base-icons/arrow-circular-outlined';
import CalculatorOutlined from '@uber/base-icons/calculator-outlined';
import ClockOutlined from '@uber/base-icons/clock-outlined';
import { styled } from 'baseui';
import { IconButton } from '../../../../common/player-controls/icon-button';
import { TimeDisplayMode } from '../../../types';
import { BUTTON_SIZE, LABELS } from './constants';
type PropsT = {
  timeDisplayMode: TimeDisplayMode;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};
const StyledIconButton = styled(IconButton, {
  '@keyframes scale-pulse': {
    '0%': {
      transform: 'scale(1)'
    },
    '50%': {
      transform: 'scale(1.2)'
    },
    '100%': {
      transform: 'scale(1)'
    }
  },
  '@keyframes rotate-once': {
    from: {
      transform: 'rotate(0deg);'
    },
    to: {
      transform: 'rotate(360deg);'
    }
  },
  ':hover #main-icon': {
    animation: 'rotate-once 0.5s linear'
  },
  ':hover #current-view-icon': {
    animation: 'scale-pulse 0.5s ease-in-out'
  }
});
const IconContainer = styled('div', {
  position: 'relative'
});
const CurrentViewIconContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  position: 'absolute',
  bottom: 0,
  right: `calc(-${$theme.sizing.scale0})`,
  backgroundColor: $theme.colors.backgroundPrimary,
  padding: $theme.sizing.scale0,
  borderRadius: $theme.borders.radius200
}));
export function SwitchFrameTimeButton({
  timeDisplayMode,
  onClick
}: PropsT) {
  const title = timeDisplayMode === TimeDisplayMode.FRAMES ? LABELS.SWITCH_TO_TIME : LABELS.SWITCH_TO_FRAME;
  return <StyledIconButton aria-label={title} onClick={onClick}>
      <IconContainer>
        <ArrowCircularOutlined id="main-icon" title={title} size={BUTTON_SIZE} />

        <CurrentViewIconContainer>
          {timeDisplayMode === TimeDisplayMode.FRAMES ? <ClockOutlined id="current-view-icon" title={title} size={BUTTON_SIZE / 2} /> : <CalculatorOutlined id="current-view-icon" title={title} size={BUTTON_SIZE / 2} />}
        </CurrentViewIconContainer>
      </IconContainer>
    </StyledIconButton>;
}